export class ReviewsFeature {
  public orderId: string;
  public name: string;
  public email: string;

  public constructor(orderId: string, name: string, email: string) {
    this.orderId = orderId;
    this.name = name;
    this.email = email;
  }
}
